import React from 'react';
import { Crown } from 'lucide-react';
import { motion } from 'framer-motion';
interface PremiumBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}
export function PremiumBadge({
  size = 'md',
  showText = true
}: PremiumBadgeProps) {
  const sizes = {
    sm: {
      icon: 'w-3 h-3',
      text: 'text-xs',
      padding: 'px-2 py-0.5'
    },
    md: {
      icon: 'w-4 h-4',
      text: 'text-sm',
      padding: 'px-3 py-1'
    },
    lg: {
      icon: 'w-5 h-5',
      text: 'text-base',
      padding: 'px-4 py-2'
    }
  };
  const {
    icon,
    text,
    padding
  } = sizes[size];
  return <motion.div whileHover={{
    scale: 1.05
  }} className={`inline-flex items-center gap-1.5 bg-gradient-to-r from-game-yellow to-game-coral ${padding} rounded-full`} data-id="element-439">
      <Crown className={`${icon} text-white`} data-id="element-440" />
      {showText && <span className={`${text} font-fredoka font-bold text-white`} data-id="element-441">
          Premium
        </span>}
    </motion.div>;
}